import React from 'react';
import { Colors } from 'works/legacy/lib/style-helper';
import { iterationMap } from 'works/legacy/services/iteration-service';

const TOTAL_PIPES = 10;

export const VisualAvailability = ({
  available,
  total,
}: {
  available: number;
  total: number;
}) => {
  const filledPipesCount =
    total > 0 ? Math.round((available / total) * TOTAL_PIPES) : 0;

  const availablePipesCount = TOTAL_PIPES - filledPipesCount;

  return (
    <>
      <div className="wk-visual-availability">
        {available}
        {iterationMap(filledPipesCount, () => (
          <span className="wk-visual-availability__pipe wk-visual-availability__pipe--strong" />
        ))}
        {iterationMap(availablePipesCount, () => (
          <span className="wk-visual-availability__pipe" />
        ))}
        {total}
      </div>
      <style jsx>{`
        .wk-visual-availability {
          text-align: center;
        }

        .wk-visual-availability__pipe:first-child {
          margin-left: 6px;
        }

        .wk-visual-availability__pipe:last-child {
          margin-right: 6px;
        }

        .wk-visual-availability__pipe {
          border-left: solid 2px ${Colors.grass};
          margin: 1px;
          opacity: 0.2;
        }

        .wk-visual-availability__pipe--strong {
          opacity: 1;
        }
      `}</style>
    </>
  );
};
